<div class="e11-flex e11-flex-col e11-items-center e11-justify-center e11-py-16 e11-gap-6 e11-text-center">
  <ng-container *ngIf="!error">
    <cnect-loader-link
      [color]="'e11-bg-skin-primary-accent'"
      [size]="'md'"
      label="{{ 'Completing channel connection…' | translate }}"
    ></cnect-loader-link>
  </ng-container>

  <ng-container *ngIf="error">
    <span class="material-icons-outlined e11-text-skin-error" style="font-size: 48px">error_outline</span>
    <div>
      <p class="e11-font-primary-demibold e11-mb-1">{{ 'We could not complete the connection.' | translate }}</p>
      <p class="e11-text-sm e11-text-skin-light">{{ 'You can return to Marketing Channels and try again.' | translate }}</p>
    </div>
    <e11-button [value]="'Back to Marketing Channels' | translate" [color]="'primary-accent'" (click)="returnToChannels()"></e11-button>
  </ng-container>
</div>
